import React, {Component} from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, AutoComplete, Select} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import css from './index.css';
import JxLstd from "../lstd";//基线
import SzjdLstd from "../szjdLstd";//深圳技大
import ZtxyLstd from "../ztxyLstd";//昭通学院
import JhysLstd from "../jhysLstd";//江汉艺术职业学院
import YnjtLstd from "../ynjtLstd";//云南交通学院
import WhrhLstd from "../whrjLstd";//武汉软件
import AhgsLstd from "../ahgsLstd"//安徽工商

const confirm = Modal.confirm;

const baseUrlPath = "/swbl/lstd"; //基础路径
/**
 * 绿色通道列表
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
            dqnd: null,
        };
    }

    componentDidMount() {
        this.getMenuCode();
        this.getDqnd();
    }

    getMenuCode = (value) => {
        let cds = ["lstd"]
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    console.log("获取定制菜单代码", res);
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    //获取当前年度
    getDqnd = () => {
        NHFetch('/newStudent/getDqnd', 'GET')
            .then(res => {
                if (res && res.data != null) {
                    this.setState({
                        dqnd: res.data
                    })                    
                }
            });
    }

    render() {
        const {menuCode, dqnd} = this.state;
        console.log("menuCode", menuCode);
        return (
          <div>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if (item.JC == "szjd") {
                          return <SzjdLstd dqnd={dqnd}/>
                      } else if (item.JC == "ztxy") {
                          return <ZtxyLstd dqnd={dqnd}/>
                      } else if (item.JC == 'jhyszy') {
                          return <JhysLstd dqnd={dqnd}/>
                      } else if (item.JC == 'ynjt') {
                          return <YnjtLstd dqnd={dqnd}/>
                      } else if (item.JC == 'whrj') {
                          return <WhrhLstd dqnd={dqnd}/>
                      } else if (item.JC == 'ahgs') {
                          return <AhgsLstd dqnd={dqnd}/>
                      } else {
                          return <JxLstd dqnd={dqnd} />
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <JxLstd dqnd={dqnd}/>}
          </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/swbl/TyLstd/index.js